import { render, staticRenderFns } from "./AuditSiteInclusionRegexForm.vue?vue&type=template&id=ff2f8714&scoped=true&"
import script from "./AuditSiteInclusionRegexForm.vue?vue&type=script&lang=js&"
export * from "./AuditSiteInclusionRegexForm.vue?vue&type=script&lang=js&"
import style0 from "./AuditSiteInclusionRegexForm.vue?vue&type=style&index=0&id=ff2f8714&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f8714",
  null
  
)

export default component.exports